import axios from "axios"
import { BASE_API_URL } from "../constants/dropdown"

export const SEND_PUSH_NOTIFICATION_REQUEST = "SEND_PUSH_NOTIFICATION_REQUEST"
export const SEND_PUSH_NOTIFICATION_SUCCESS = "SEND_PUSH_NOTIFICATION_SUCCESS"
export const SEND_PUSH_NOTIFICATION_FAIL = "SEND_PUSH_NOTIFICATION_FAIL"
export const SEND_PUSH_NOTIFICATION_RESET = "SEND_PUSH_NOTIFICATION_RESET"

const getConfig = (getState) => {
  const {
    admin2faLogin: { userInfo }
  } = getState()
  const token = userInfo?.token?.access_token
  return {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    }
  }
}

export const sendBulkPushNotification = (data) => async (dispatch, getState) => {
  try {
    dispatch({ type: SEND_PUSH_NOTIFICATION_REQUEST })
    const config = getConfig(getState)
    const { data: responseData } = await axios.post(
      `${BASE_API_URL}/admin/notification/bulk/push-notification`,
      data,
      config
    )
    dispatch({ type: SEND_PUSH_NOTIFICATION_SUCCESS, payload: responseData })
  } catch (error) {
    dispatch({
      type: SEND_PUSH_NOTIFICATION_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
    })
  }
}

export const resetPushNotification = () => (dispatch) => {
  dispatch({ type: SEND_PUSH_NOTIFICATION_RESET })
}